// extracted by mini-css-extract-plugin
module.exports = {"main":"livestream-event-PriceInfoTooltip__main--1UK83","tooltip":"livestream-event-PriceInfoTooltip__tooltip--3YyK3"};